import { Checkbox } from "@material-ui/core";
import { FC } from "react";
import { useStyles } from "../styles";
import { FleetData } from "types/DaAndFleet";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useDispatch } from "react-redux";
import { addOrRemoveIdFromUpdateList } from "actions/daAndFleetActions";

interface FleetCheckboxProps {
  data: FleetData;
  disabled?: boolean;
}

export const FleetCheckbox: FC<FleetCheckboxProps> = ({ data, disabled }) => {
  const classes = useStyles();
  const {
    fleetData: { idListForUpdate },
  } = useTypeSelectors((state) => state.daAndFleets);
  const dispatch = useDispatch();

  return (
    <Checkbox
      onChange={() => dispatch(addOrRemoveIdFromUpdateList("fleet", data?.id))}
      checked={idListForUpdate?.includes(data.id)}
      className={classes.selectCheckbox}
      disabled={disabled}
    />
  );
};
